import { InputTypes } from "../inputs/constants";

export const filters = [
  {
    description: "Minimum Assessed Improvement Value",
    key: "assessedImprovementValueMin",
    label: "Minimum Assessed Improvement Value",
    type: InputTypes.NUMBER,
  },
  {
    description: "Maximum Assessed Improvement Value",
    key: "assessedImprovementValueMax",
    label: "Maximum Assessed Improvement Value",
    type: InputTypes.NUMBER,
  },
  {
    description: "Minimum Assessed Improvement Value",
    key: "assessedLandValueMin",
    label: "Minimum Assessed Improvement Value",
    type: InputTypes.NUMBER,
  },
  {
    description: "Maximum Assessed Land Value",
    key: "assessedLandValueMax",
    label: "Maximum Assessed Land Value",
    type: InputTypes.NUMBER,
  },
  {
    description: "Minimum Assessed Value",
    key: "assessedValueMin",
    label: "Minimum Assessed Value",
    type: InputTypes.NUMBER,
  },
  {
    description: "Maximum Assessed Value",
    key: "assessedValueMax",
    label: "Maximum Assessed Value",
    type: InputTypes.NUMBER,
  },
  {
    description:
      "Indicates whether the property has an attic and possibly its specifications.",
    key: "attic",
    label: "Attic",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
  {
    description: "Minimum Auction Date",
    key: "auctionDateMin",
    label: "Minimum Auction Date",
    type: InputTypes.DATE_PICKER,
  },
  {
    description: "Maximum Auction Date",
    key: "auctionDateMax",
    label: "Maximum Auction Date",
    type: InputTypes.DATE_PICKER,
  },
  {
    description: "Indicates whether the owner has filed for bankruptcy.",
    key: "bankruptcy",
    label: "Bankruptcy",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
  {
    description: "Minimum Bankruptcy Recording Date",
    key: "bankruptcyRecordingDateMin",
    label: "Minimum Bankruptcy Recording Date",
    type: InputTypes.DATE_PICKER,
  },
  {
    description: "Maximum Bankruptcy Recording Date",
    key: "bankruptcyRecordingDateMax",
    label: "Maximum Bankruptcy Recording Date",
    type: InputTypes.DATE_PICKER,
  },
  {
    description:
      "Indicates whether the property has a basement and its specifications.",
    key: "basement",
    label: "bBasement",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
  {
    description: "Minimum Number Of Bathrooms",
    key: "bathroomsMin",
    label: "Minimum Number Of Bathrooms",
    type: InputTypes.NUMBER,
  },
  {
    description: "Maximum Number Of Bathrooms",
    key: "bathroomsMax",
    label: "Maximum Number Of Bathrooms",
    type: InputTypes.NUMBER,
  },
  {
    description: "Minimum Number Of Bedrooms",
    key: "bedroomsMin",
    label: "Minimum Number Of Bedrooms",
    type: InputTypes.NUMBER,
  },
  {
    description: "Maximum Number Of Bedrooms",
    key: "bedroomsMax",
    label: "Maximum Number Of Bedrooms",
    type: InputTypes.NUMBER,
  },
  {
    description:
      "Indicates whether the property is listed below its estimated market value.",
    key: "belowMarketPrice",
    label: "Below Market Price",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
  {
    description: "Minimum Below Market Price Rate",
    key: "belowMarketPriceRateMin",
    label: "Minimum Below Market Price Rate",
    type: InputTypes.NUMBER,
  },
  {
    description: "Maximum Below Market Price Rate",
    key: "belowMarketPriceRateMax",
    label: "Maximum Below Market Price Rate",
    type: InputTypes.NUMBER,
  },
  {
    description: "Indicates whether the owner is associated with a business.",
    key: "businessOwner",
    label: "Business Owner",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
  {
    description: "Identifies if the property was purchased by a cash buyer.",
    key: "cashBuyer",
    label: "Cash Buyer",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
  {
    description: "Does the property have a pool",
    key: "pool",
    label: "Pool",
    options: [
      {
        label: "Any",
      },
      {
        label: "Yes",
        value: true,
      },
      {
        label: "No",
        value: false,
      },
    ],
    type: InputTypes.RADIO,
  },
];

export const formatFilters = (filters = []) => {
  return filters.reduce((acc, filter) => {
    const { key, value } = filter;
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }

    return acc;
  }, {});
};
